export default __webpack_public_path__ + "a411bea0b5c13f91a072b7cac5f757cf.woff";